export default __webpack_public_path__ + "assets/service-agreement.18f87bbe5d5fb5cf43cdad5fb01a0da6.pdf";